var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from '../../../button/button';
import { classNames, renderIcon } from '../../../../utils';
import * as stackedListStyles from '../../stacked-list.styles';
import * as styles from './action-list-item.styles';
import Typography from '../../../typography/typography';
export var ActionListItem = function (_a) {
    var _b;
    var item = _a.item, id = _a.id, onClickItem = _a.onClickItem;
    var getIcon = function (iconType) {
        return renderIcon(iconType, styles.actionIcon);
    };
    var buttonType = (_b = item.buttonType) !== null && _b !== void 0 ? _b : 'filled';
    return (_jsx("div", __assign({ className: classNames(item.containerStyle, styles.actionListItemContainer), id: id }, { children: _jsxs("div", __assign({ className: styles.contentWrapper }, { children: [_jsx("div", __assign({ className: stackedListStyles.textRowsWrapper }, { children: _jsx("div", __assign({ className: classNames(styles.actionParagraphWrapper) }, { children: _jsxs(_Fragment, { children: [_jsx("p", __assign({ className: !item.switchTextStyles
                                        ? classNames(item.titleStyle, styles.actionTitle)
                                        : classNames(item.titleStyle, styles.actionSubTitle) }, { children: item.title })), _jsxs("p", __assign({ className: item.switchTextStyles
                                        ? classNames(item.subTitleStyle, styles.actionTitleInput)
                                        : classNames(item.subTitleStyle, styles.actionSubTitle) }, { children: [item.hasMarkup && (_jsx("span", { dangerouslySetInnerHTML: { __html: item.subTitle || '' }, className: "truncate" })), !item.hasMarkup && (_jsx("span", __assign({ className: "truncate" }, { children: item.subTitle })))] }))] }) })) })), (!!onClickItem || !!item.onActionClick) && (_jsx("div", __assign({ onClick: function () {
                        if (!!item.onActionClick)
                            item.onActionClick();
                        else if (!!onClickItem)
                            onClickItem(item);
                    } }, { children: item.actionName && (_jsxs(Button, __assign({ type: buttonType, color: "secondaryAccent2", size: "small" }, { children: [_jsx(Typography, { className: 'mr-1', type: 'buttonSmall', color: 'secondary', text: item.actionName }), item.actionIcon && getIcon(item.actionIcon)] }))) })))] })) })));
};
export default ActionListItem;
//# sourceMappingURL=action-list-item.js.map